import dynamic from 'next/dynamic';
import { IModFeature } from 'mod/featureV2/interface';
import { IVariant } from 'base/interfaces/product';
import { FeatureTitles } from 'mod/featureV2/FeatureTitles';

const FeatureMarquee = dynamic(() => import('@pro/feature/FeatureMarquee'), { ssr: true });
const FeatureTextBannerTabs = dynamic(() => import('@pro/feature/FeatureTextBannerTabs'), { ssr: true });
const FeatureOverlayBanner = dynamic(() => import('@pro/feature/FeatureOverlayBanner'), { ssr: true });
const FeatureNavOverlayBanner = dynamic(() => import('@pro/feature/FeatureNavOverlayBanner'), { ssr: true });
const FeatureBanner = dynamic(() => import('@pro/feature/FeatureBanner'), { ssr: true });
const FeatureAnchorsBanner = dynamic(() => import('@pro/feature/FeatureAnchorsBanner'), { ssr: true });
const FeatureSwiperToggleBanner = dynamic(() => import('@pro/feature/FeatureSwiperToggleBanner'), { ssr: true });
const FeatureCollapse = dynamic(() => import('@pro/feature/FeatureCollapse'), { ssr: true });
const FeatureTechSpecs = dynamic(() => import('@pro/feature/FeatureTechSpecs'), { ssr: true });
const FeaturePicTxtLinkage = dynamic(() => import('@pro/feature/FeaturePicTxtLinkage'), { ssr: true });
const FeatureSwiperPicTxt = dynamic(() => import('@pro/feature/FeatureSwiperPicTxt'), { ssr: true });
const FeatureSwiperReviews = dynamic(() => import('@pro/feature/FeatureSwiperReviews'), { ssr: true });
const FeatureWaterFall = dynamic(() => import('@pro/feature/FeatureWaterFall'), { ssr: true });
const FeatureTabsProducts = dynamic(() => import('@pro/feature/FeatureTabsProducts'), { ssr: true });
const FeatureBlog = dynamic(() => import('@pro/feature/FeatureBlog'), { ssr: true });
const FeatureArticle = dynamic(() => import('@pro/feature/FeatureArticle'), { ssr: true });
const FeatureScaleVideo = dynamic(() => import('mod/featureV2/FeatureScaleVideo'), { ssr: true });
const FeatureParallax = dynamic(() => import('mod/featureV2/FeatureParallax'), { ssr: true });
const FeatureBackToTop = dynamic(() => import('@pro/feature/FeatureBackToTop'), { ssr: true });
const FeatureStickyTopBar = dynamic(() => import('@pro/feature/FeatureStickyTopBar'), { ssr: true });
const FeatureProductBanner = dynamic(() => import('@pro/feature/FeatureProductBanner'), { ssr: true });
const FeatureBuyButton = dynamic(() => import('mod/featureV2/FeatureBuyButton'), { ssr: true });

type IModFeatureProps = {
    feature: IModFeature;
    variant?: IVariant;
};

export function ModFeature(props: IModFeatureProps): Globals.JSXRenderType {
    const { feature, variant } = props;

    switch (feature.type) {
        case 'textBannerTabs':
            return <FeatureTextBannerTabs feature={feature}/>;
        case 'marquee':
            return <FeatureMarquee feature={feature}/>;
        case 'navOverlayBanner':
            return <FeatureNavOverlayBanner feature={feature}/>;
        case 'overlayBanner':
            return <FeatureOverlayBanner feature={feature}/>;
        case 'banner':
            return <FeatureBanner feature={feature}/>;
        case 'anchorsBanner':
            return <FeatureAnchorsBanner feature={feature}/>;
        case 'swiperToggleBanner':
            return <FeatureSwiperToggleBanner feature={feature}/>;
        case 'collapse':
            return <FeatureCollapse feature={feature}/>;
        case 'techSpecs':
            return <FeatureTechSpecs feature={feature}/>;
        case 'picTxtLinkage':
            return <FeaturePicTxtLinkage feature={feature}/>;
        case 'swiperPicTxt':
            return <FeatureSwiperPicTxt feature={feature}/>;
        case 'swiperReviews':
            return <FeatureSwiperReviews feature={feature}/>;
        case 'waterFall':
            return <FeatureWaterFall feature={feature}/>;
        case 'tabsProducts':
            return <FeatureTabsProducts feature={feature}/>;
        case 'blog':
            return <FeatureBlog feature={feature}/>;
        case 'article':
            return <FeatureArticle feature={feature}/>;
        case 'scaleVideo':
            return <FeatureScaleVideo feature={feature}/>;
        case 'parallax':
            return <FeatureParallax feature={feature}/>;
        case 'backToTop':
            return <FeatureBackToTop feature={feature}/>;
        case 'titles':
            return <FeatureTitles feature={feature}/>;
        case 'stickyTopBar':
            return <FeatureStickyTopBar feature={feature} variant={variant}/>;
        case 'productBanner':
            return <FeatureProductBanner feature={feature} variant={variant}/>;
        case 'buyButton':
            return <FeatureBuyButton feature={feature} variant={variant}/>;
        default:
            return null
    }
}